import { css } from '@emotion/react';

const frameStyles = css`
  width: 100%;
  height: 100vh;
  border: none;
  display: block;
`;

export default function DeliverabilityOpsToolPage() {
  return (
    <iframe
      css={frameStyles}
      src="/Deliverability Ops - Sending Limit Read-Only.html"
      title="Deliverability Ops Tool"
    />
  );
}
